import { faExclamationTriangle } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  Box,
  Button,
  DestructiveIcon,
  Modal,
  ModalContent,
  ModalFooter,
  ModalTitle,
  Text,
} from '@modusign/design-system';

import { IFileUploadError } from './fileUploadErrorBuilder';

interface FileUploadErrorModalProps {
  errors: IFileUploadError[] | null;
  onConfirm: () => void;
}

export default function FileUploadErrorModal({ errors, onConfirm }: FileUploadErrorModalProps) {
  if (!errors || errors.length === 0) {
    return null;
  }

  return (
    <Modal isOpen maxWidth="xmd" onClose={onConfirm}>
      <ModalTitle icon={<DestructiveIcon color="iconPrimaryBase" />}>파일 업로드 안내</ModalTitle>
      <ModalContent>
        <Text textAlign="center">{errors.length}개 파일을 업로드하지 못했습니다.</Text>
        <Box
          as="main"
          bg="boxBackgroundNeutralBase"
          border="1px solid"
          borderColor="boxBorderNeutralBase"
          height="300px"
          mt={7}
          overflow="auto"
          px={7}
          py={4}
        >
          <Box as="table" sx={{ tableLayout: 'fixed' }} width="100%">
            <thead>
              <Box as="tr" borderBottom="1px solid" borderBottomColor="#e4e4e4" textAlign="left">
                <Text as="th" color="textNeutralVeryLight" fontSize="sm">
                  업로드 실패한 파일
                </Text>
                <Text as="th" color="textNegativeBase" fontSize="sm" py={4} sx={{ width: '200px' }}>
                  <Box as="span" mr={1}>
                    <FontAwesomeIcon icon={faExclamationTriangle} />
                  </Box>
                  실패 사유
                </Text>
              </Box>
            </thead>
            <tbody>
              {errors.map((error, idx) => (
                // eslint-disable-next-line react/no-array-index-key
                <Box as="tr" borderBottom="1px solid" borderBottomColor="#e4e4e4" key={idx}>
                  <Box as="td" pr={6} py={4}>
                    <Text
                      as="div"
                      fontWeight="medium"
                      sx={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}
                    >
                      {error.fileName}
                    </Text>
                    {error.documentName && (
                      <Text
                        as="div"
                        color="textNeutralVeryLight"
                        fontSize="sm"
                        sx={{
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                          whiteSpace: 'nowrap',
                          mt: 1,
                        }}
                      >
                        {error.documentName}
                      </Text>
                    )}
                  </Box>
                  <Text
                    as="td"
                    color="textNeutralLight"
                    fontSize="sm"
                    sx={{
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      whiteSpace: 'nowrap',
                      py: 4,
                    }}
                  >
                    <ul>
                      {error.getErrorMessages().map((value, idx) => (
                        // eslint-disable-next-line react/no-array-index-key
                        <Text as="li" fontSize="13px" key={idx}>
                          {value}
                        </Text>
                      ))}
                    </ul>
                  </Text>
                </Box>
              ))}
            </tbody>
          </Box>
        </Box>
      </ModalContent>
      <ModalFooter>
        <Button onClick={onConfirm}>확인</Button>
      </ModalFooter>
    </Modal>
  );
}
